import { Selection } from '@leverege/ui-redux';
import { Constants } from '@leverege/api-redux';
const hook = (state, action) => {
  const type = action.type;
  if (type === Constants.INTERFACE_REMOVE || type === Constants.INTERFACE_REMOVE_USER) {
    const {
      id
    } = action;
    return Selection.hookRemoveFromAll(state, id);
  }
  return state;
};
const install = () => {
  Selection.addHook(hook);
};
export default {
  hook,
  install
};